import {
  Button,
  HStack,
  VStack,
  Text,
  Input,
  Collapse,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import ColumnManager from "../column_manager";
import { INN_COLUMN_KEY } from "../../utils/report_columns";


const SelfFilters = observer(() => {
  const { pageStore } = useStores();

  return (
    <>
      <Collapse in={pageStore.open_filter} style={{ overflow: pageStore.open_filter ? 'visible' : 'hidden' }} animateOpacity>
        <HStack textColor={"white"} width={"100%"} justifyItems={"center"} align={"start"} gap={"20px"} mb={4} flexWrap="wrap">
          <ColumnManager
            report="openProfit"
            columns={pageStore.columnConfigOpenProfit}
            onChange={(newColumns) => pageStore.setColumnConfigOpenProfit(newColumns)}
            introducedColumnKeys={[INN_COLUMN_KEY]}
          />
          <VStack>
            <Text fontSize={"20px"}>Номер счёта</Text>
            <Input
              value={pageStore.order_num_filter}
              onChange={(e) => pageStore.setOrderNumFilter(e.target.value)}
              width={"10vw"}
            />
          </VStack>
          <VStack>
            <Text fontSize={"20px"}>ID сделки</Text>
            <Input
              value={pageStore.order_deal_filter}
              onChange={(e) => pageStore.setOrderDealFilter(e.target.value)}
              width={"10vw"}
            />
          </VStack>
        </HStack>
      </Collapse>
      <HStack
        justify="space-between"
        mb={4}
        borderBottom="1px solid #444"
        pb={3}
        w="full"
      >
        <Button
          size="sm"
          bg="#333"
          color="white"
          onClick={() => pageStore.setOpenFilters(!pageStore.open_filter)}
          _hover={{ bg: "#444" }}
          leftIcon={pageStore.open_filter ? <span>−</span> : <span>+</span>}
        >
          {pageStore.open_filter ? "Скрыть фильтры" : "Открыть фильтры"}
        </Button>
        <HStack spacing={4} flex="1">
          <Text fontSize="12px" fontWeight="bold" color="gray.400" whiteSpace="nowrap">
            Высота строк: {pageStore.rowHeight}
          </Text>

          <HStack spacing={2} flex="1" maxW="300px">
            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.max(0, pageStore.rowHeight - 1))}
            >
              -
            </Button>

            <Slider
              id="row-padding-slider"
              min={0}
              max={10}
              step={1}
              value={pageStore.rowHeight}
              onChange={(v) => pageStore.setRowHeight(v)}
              colorScheme="green"
            >
              <SliderTrack bg="#444">
                <SliderFilledTrack />
              </SliderTrack>
              <SliderThumb boxSize={3} />
            </Slider>

            <Button
              size="xs"
              onClick={() => pageStore.setRowHeight(Math.min(10, pageStore.rowHeight + 1))}
            >
              +
            </Button>
          </HStack>
          <Text
            fontSize="12px"
            color="gray.400"
            fontWeight="600"
            whiteSpace="nowrap"
          >
            Время запроса: {pageStore.request_time.toFixed(2)} сек.
          </Text>
        </HStack>
      </HStack>
    </>
  )
})

export default SelfFilters
